import Swiper from 'swiper/bundle';

function upsellSwiper() {
  const swiperUpsell = new Swiper('.upsell-content', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
  });
}

function atcProductUpsell() {
  $("input.variant-color-input[type=\"checkbox\"]").on('click', function () {
    var $variant = $(this);
    if ($variant.is(":checked")) {
      var group = "input.variant-color-input[name='" + $variant.attr("name") + "']";
      $(group).prop("checked", false);
      $variant.prop("checked", true);
    } else {
      $variant.prop("checked", true);
    }

    // Send variant id of selected color
    $("#atc-" + $variant.attr("name")).prop("href", "/cart/add?id=" + $variant.attr("value") + "&quantity=1");

    // Show selected variant
    var imgGroup = "img.img-" + $variant.attr("name");
    $(imgGroup).prop("style", "display: none");
    $("#img-" + $variant.attr("id")).prop("style", "display: block");

    // Disable atc for sold out variants
    if ($variant.attr("available") === "true") {
      $("#atc-div-" + $variant.attr("name")).addClass("atc-upsell-product-container__available").removeClass("atc-upsell-product-container__unavailable");
    } else {
      $("#atc-div-" + $variant.attr("name")).addClass("atc-upsell-product-container__unavailable").removeClass("atc-upsell-product-container__available");
    }
  });

}

const observeDOMChanges = (element) => {
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.previousSibling.className === "cart-drawer") {
        //console.log("Recargando funciones!!");
        observer.disconnect();
        upsellSwiper();
        atcProductUpsell();
        connectObserver();
      }
    }
  });
  const config = { attributes: true, childList: true, subtree: false };
  observer.observe(element, config);
};

function connectObserver() {
  const targetElement = document.querySelector('#shopify-section-cart-drawer');
  const targetElementB = document.querySelector('#shopify-section-cart-drawer-b');
  const targetElementC = document.querySelector('#shopify-section-cart-drawer-c');
  if (targetElement) {
    observeDOMChanges(targetElement);
  }
  if (targetElementB) {
    observeDOMChanges(targetElementB);
  }
  if (targetElementC) {
    observeDOMChanges(targetElementC);
  }
}

function runCartDrawerUpsell() {
  if (window.getComputedStyle(document.querySelector("#cart-drawer--upsell-ab")).display != "none") {
    upsellSwiper();
    atcProductUpsell();
    connectObserver();
  }
}

export default runCartDrawerUpsell;
